import { Button } from '@mui/material';
import { useRouter } from 'next/router';
import { Breadcrumb } from '../Breadcrumb';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import { getHeaderClasses } from './helper';
import { HeaderProps } from './types';

const Header = (props: HeaderProps) => {
  const { className, title, button, hasBackButton, breadcrumb, ...restProps } =
    props;
  const router = useRouter();

  const finalClassName = [getHeaderClasses(), className].join(' ');

  const handleBack = () => {
    router.back();
  };

  const renderTopContent = () => {
    if (!breadcrumb && !hasBackButton) return null;

    return (
      <div className="flex max-w-full justify-between">
        {breadcrumb && <Breadcrumb {...breadcrumb} />}
        {hasBackButton && (
          <Button
            variant="low_emphasis_v2"
            startIcon={
              <Icon
                iconName="arrow-right-md"
                width={16}
                height={16}
                className="-mr-1"
              />
            }
            className="!px-[10px] !py-2"
            onClick={handleBack}
          >
            <Typography variant="button3">Quay lại</Typography>
          </Button>
        )}
      </div>
    );
  };

  return (
    <header {...restProps} className={finalClassName}>
      {renderTopContent()}
      <div className="flex items-center justify-between">
        <Typography variant="display2"> {title}</Typography>
        {button && (
          <Button
            variant="high_emphasis_v2"
            startIcon={
              <Icon
                iconName={button.iconName}
                width={16}
                height={16}
                className="-mr-1"
              />
            }
            className="!px-[10px] !py-2"
            onClick={button.onClick}
          >
            <Typography variant="button3">{button.title}</Typography>
          </Button>
        )}
      </div>
    </header>
  );
};

export default Header;
